import { Component } from '@angular/core';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss'],
    standalone: false
})
export class AuthCallbackComponent { }
